import { Overlay } from "../../../ui/atoms/Overlay";

interface KeyboardShortcutsHelpProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}

const SHORTCUTS = [
  { key: "Ctrl+K", description: "Rechercher" },
  { key: "Ctrl+Z", description: "Annuler" },
  { key: "Ctrl+Shift+Z", description: "Refaire" },
  { key: "1-6", description: "Changer de vue" },
  { key: "N", description: "Nouvelle tâche" },
  { key: "E", description: "Nouvel événement" },
  { key: "F", description: "Mode focus" },
  { key: "?", description: "Aide clavier" },
] as const;

export function KeyboardShortcutsHelp({
  isOpen,
  onClose,
}: KeyboardShortcutsHelpProps) {
  return (
    <Overlay open={isOpen} onClose={onClose}>
      <div className="bg-surface border border-border rounded-2xl shadow-xl p-6 max-w-sm w-full max-h-96 overflow-y-auto">
        <h2 className="text-lg font-bold text-ink mb-4">Raccourcis clavier</h2>

        <div className="grid grid-cols-2 gap-4">
          {SHORTCUTS.map((shortcut) => (
            <div key={shortcut.key} className="flex flex-col gap-1">
              <kbd className="text-xs font-mono font-semibold text-accent bg-surface-alt px-2 py-1 rounded">
                {shortcut.key}
              </kbd>
              <p className="text-xs text-ink-muted">{shortcut.description}</p>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full px-4 py-2 text-sm font-semibold text-white bg-accent rounded-lg hover:bg-accent-hover transition-colors"
        >
          Fermer
        </button>
      </div>
    </Overlay>
  );
}
